import { useMemo } from 'react';
import { ProgressBarTab as ProgressBarTabType } from './useProgressBar';

export interface ProgressBarTabProps {
  tab: ProgressBarTabType;
}

const getTabColor = (tab: ProgressBarTabType): string => {
  if (tab.type === 'multi') return '';
  if (tab.final && tab.isActive) return 'bg-purple-300';
  if (tab.isPassed) return 'bg-purple-300';
  if (tab.isActive) return 'bg-neutral-900';
  return 'bg-neutral-400';
};

const ProgressBarTab: React.FunctionComponent<ProgressBarTabProps> = function ({
  tab,
}) {
  const className = useMemo(() => ['h-1.5', getTabColor(tab)].join(' '), [tab]);
  if (tab.type === 'multi')
    return (
      <div style={{ width: tab.width }} className="flex flex-row">
        {tab.subbars.map((subtab) => (
          <ProgressBarTab key={subtab.index} tab={subtab} />
        ))}
      </div>
    );
  return <div style={{ width: tab.width }} className={className} />;
};

export default ProgressBarTab;
